import { TingleIcon } from './icon';
import { ShampooIconVariant } from './variant';
import { TingleLogoIconVariant } from '../components/tingle/LogoIcon';

type TingleVariantType = {
  [key in keyof typeof TingleIcon]: string[];
};

export const TingleVariant: TingleVariantType = {
  Logo: Object.values(TingleLogoIconVariant),
  Store: [''],
  Incentive: [''],
  Sprout: [''],
  Potion: Object.values(ShampooIconVariant),
  Charge: [''],
};
